import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {httpUpdateUserGroup, HttpUpdateUserGroupOptions} from '@/features/user-groups/http/user-groups.http.ts'
import {captureException} from '@sentry/react'
import {UserGroup} from '@/features/user-groups/types.ts'
import {z} from 'zod'
import {MUTATION_KEYS} from '@/queryClient'

// The API returns the user group directly, not nested under a UserGroup property
const ResponseShape = UserGroup
type ResponseShape = z.infer<typeof ResponseShape>

export const useUpdateUserGroup = (
    options?: Omit<UseMutationOptions<ResponseShape, Error, HttpUpdateUserGroupOptions, unknown>, 'mutationFn'>
) => {
    return useMutation({
        mutationKey: [MUTATION_KEYS.UPDATE_USER_GROUP],
        mutationFn: (mutationParams: HttpUpdateUserGroupOptions) =>
            parseAxiosPromise({
                axiosPromise: httpUpdateUserGroup(mutationParams),
                onZodError: captureException,
                responseShape: ResponseShape
            }),
        ...options
    })
}
